import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, UserIcon, BellIcon, SettingsIcon } from 'lucide-react';
import { SearchBar } from './SearchBar';
const RECENT_SEARCHES = [{
  id: '1',
  title: 'Taylor Swift',
  subtitle: 'Artist'
}, {
  id: '2',
  title: 'Podcast Daily',
  subtitle: 'Podcast • Spotify'
}, {
  id: '3',
  title: 'Lofi Beats',
  subtitle: 'Playlist • Spotify'
}];
interface HeaderProps {
  onBack: () => void;
  onForward: () => void;
  canGoBack: boolean;
  canGoForward: boolean;
  onSearchClick: () => void;
  onNotificationsClick: () => void;
  onSettingsClick: () => void;
  onUserClick: () => void;
  isMobile?: boolean;
}
export const Header = ({
  onBack,
  onForward,
  canGoBack,
  canGoForward,
  onSearchClick,
  onNotificationsClick,
  onSettingsClick,
  onUserClick,
  isMobile = false
}: HeaderProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const handleSearch = (query: string) => {
    setSearchQuery(query);
    console.log('Search:', query);
  };
  // Mobile header is simpler
  if (isMobile) {
    return <header className="bg-[#121212] bg-opacity-95 sticky top-0 z-10" data-id="element-47">
        <div className="flex items-center justify-between p-4" data-id="element-48">
          <div className="flex items-center" data-id="element-49">
            <div className="w-8 h-8 rounded-full bg-[#333] flex items-center justify-center" data-id="element-50">
              <UserIcon className="w-5 h-5 text-gray-300" onClick={onUserClick} data-id="element-51" />
            </div>
          </div>
          <div className="flex space-x-2" data-id="element-52">
            <button className="p-2 hover:bg-[#282828] rounded-full transition-colors" onClick={onNotificationsClick} data-id="element-53">
              <BellIcon className="w-5 h-5 text-gray-300" data-id="element-54" />
            </button>
            <button className="p-2 hover:bg-[#282828] rounded-full transition-colors" onClick={onSettingsClick} data-id="element-55">
              <SettingsIcon className="w-5 h-5 text-gray-300" data-id="element-56" />
            </button>
          </div>
        </div>
        <div className="px-4 pb-4" data-id="element-57">
          <div className="flex space-x-2" data-id="element-58">
            <button className="rounded-full bg-green-500 px-6 py-2 text-sm font-medium" data-id="element-59">
              All
            </button>
            <button className="rounded-full bg-[#333] px-6 py-2 text-sm font-medium" data-id="element-60">
              Music
            </button>
            <button className="rounded-full bg-[#333] px-6 py-2 text-sm font-medium" data-id="element-61">
              Podcasts
            </button>
          </div>
        </div>
      </header>;
  }
  // Desktop header
  return <header className="bg-[#121212] bg-opacity-95 sticky top-0 z-10" data-id="element-62">
      <div className="flex items-center justify-between p-4 md:p-8" data-id="element-63">
        <div className="flex items-center flex-1" data-id="element-64">
          <div className="flex space-x-2 mr-4" data-id="element-65">
            <button className={`rounded-full p-1 md:p-1.5 ${canGoBack ? 'bg-black/70 hover:bg-black/90' : 'bg-black/40 cursor-not-allowed'}`} onClick={onBack} disabled={!canGoBack} data-id="element-66">
              <ChevronLeftIcon className={`w-5 h-5 md:w-6 md:h-6 ${canGoBack ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-67" />
            </button>
            <button className={`rounded-full p-1 md:p-1.5 ${canGoForward ? 'bg-black/70 hover:bg-black/90' : 'bg-black/40 cursor-not-allowed'}`} onClick={onForward} disabled={!canGoForward} data-id="element-68">
              <ChevronRightIcon className={`w-5 h-5 md:w-6 md:h-6 ${canGoForward ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-69" />
            </button>
          </div>
          <div className="hidden md:block w-[400px]" onClick={onSearchClick} data-id="element-70">
            <SearchBar recentSearches={RECENT_SEARCHES} onSearch={handleSearch} onClearRecentSearches={() => console.log('Clear searches')} onRemoveRecentSearch={id => console.log('Remove search:', id)} placeholder="What do you want to listen to?" data-id="element-71" />
          </div>
        </div>
        <div className="flex items-center space-x-2 md:space-x-4" data-id="element-72">
          <button className="p-2 hover:bg-[#282828] rounded-full transition-colors" onClick={onNotificationsClick} data-id="element-73">
            <BellIcon className="w-5 h-5 text-gray-300" data-id="element-74" />
          </button>
          <button className="p-2 hover:bg-[#282828] rounded-full transition-colors md:block hidden" onClick={onSettingsClick} data-id="element-75">
            <SettingsIcon className="w-5 h-5 text-gray-300" data-id="element-76" />
          </button>
          <button className="flex items-center bg-[#282828] rounded-full p-0.5 hover:bg-opacity-80 transition-colors" onClick={onUserClick} data-id="element-77">
            <div className="bg-[#333] rounded-full p-1" data-id="element-78">
              <UserIcon className="w-5 h-5 md:w-6 md:h-6 text-gray-300" data-id="element-79" />
            </div>
            <span className="text-white font-medium mx-2 md:mx-3 text-sm md:text-base hidden md:block" data-id="element-80">
              User Name
            </span>
          </button>
        </div>
      </div>
    </header>;
};